import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
    & > .modal-xl {
      max-width: 550px;
      @media (max-width: 700px) {
        padding: 30px;
      }
    }
  & .modal-content {
    border-radius: 16px;
    border: none;
    width: 100% !important;
    @media (max-width: 500px) {
        width: auto !important;
      }
 
    & > .modal-body {
      padding: 0px;

      & > .close-icon {
        background-color: transparent;
        position: absolute;
        right: 20px;
        top: 15px;
        border: none;
      }
    }
  }
`;

export default StyledModal;
